export const TOGGLE_SLIDE_PANEL = 'TOGGLE_SLIDE_PANEL';
export const SET_SLIDE_URL = 'SET_SLIDE_URL';
export const SET_SLIDE_STATUS = 'SET_SLIDE_STATUS';
/**
 * スライドパネルを「開く」（トグルではなく必ず表示）。
 * AI評価レポートが届いたときに自動で開くために使う。
 */
export const OPEN_SLIDE_PANEL = 'OPEN_SLIDE_PANEL';
/** 会話評価を依頼した（進行中になる）。 */
export const FEEDBACK_REQUESTED = 'FEEDBACK_REQUESTED';
/** 会話評価が失敗した（送れなかった／時間切れ）。 */
export const FEEDBACK_FAILED = 'FEEDBACK_FAILED';
/** 進行ポップアップの表示/非表示（閉じて待つ／詳細）。 */
export const SET_FEEDBACK_MODAL = 'SET_FEEDBACK_MODAL';
/** 会話評価の表示を終える（レポートを開いた／あとで見る）。 */
export const DISMISS_FEEDBACK = 'DISMISS_FEEDBACK';
